import CustomersWidgets from './CustomersWidgets';

export default CustomersWidgets;
